import React from 'react'
import { MenuButton, Icon } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'

const hasUsageTasks = (tasks = []) => {
  for (const job of tasks) {
    for (const version of job.versions || []) {
      for (const task of version.tasks || []) {
        if (task?.type?.shortname === 'USAGE') return true
      }
    }
  }
  return false
}

const DisableUsageReminder = ({ order, refetch, readOnly }) => {
  const { formatMessage } = useIntl()

  if (!hasUsageTasks(order?.tasks)) {
    return null
  }

  const onClick = () => {
    fetch(`/rest/v1/order/${order.uid}`, {
      method: 'PUT',
      body: JSON.stringify({
        usage_reminder_disabled: !!(+order.usage_reminder_disabled) ? 0 : 1
      })
    })
      .then((response) => response.json())
      .then((response) => {
        if (!!(+response.usage_reminder_disabled)) {
          toastr.success(formatMessage(messages.disabled))
        } else {
          toastr.success(formatMessage(messages.enabled))
        }
        refetch()
      })
      .catch((error) => window.alert(error))
  }

  return (
    <Menu.Item key='DisableUsageReminder' disabled={readOnly}>
      {(props) => (
        <MenuButton disabled={readOnly} {...props} onClick={onClick}>
          <div className="flex justify-between items-center space-x-4">
            <span>{formatMessage(messages.title)}</span>
            <Icon icon={!!(+order.usage_reminder_disabled) ? 'check-square' : 'square'} />
          </div>
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default DisableUsageReminder
